export const isQrEntry = () => {
  // Primary check: allocationId is set when user enters via QR or joins via share link
  const allocationId = localStorage.getItem("allocationId");
  const guestInfo = localStorage.getItem("guestInfo");

  const isQr = Boolean(allocationId || guestInfo);

  return isQr;
};

// export const isQrFlow = () => {
//   const params = new URLSearchParams(window.location.search);
//   const hasParams = Boolean(params.get("restaurantId") && params.get("tableId"));
//   const hasAllocation = Boolean(localStorage.getItem("allocationId"));
//   return hasParams || hasAllocation;
// };
